import * as React from "react";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import Badge from "components/bootstrap/Badge";
const StyledBadge = styled(Badge)(
  ({ onClick }) => css`
    cursor: ${onClick ? "pointer" : "default"};
  `
);
const CountBadge = ({ onClick = void 0, className = "", title = void 0, count }, ref) => /* @__PURE__ */ React.createElement(StyledBadge, { bsStyle: !count ? "gray" : "info", className, onClick, ref, title }, count);
export default forwardRef(CountBadge);
